<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button v-if="orderStatus===0" content="button.taken" icon="vxe-icon-search" mode="text" status="primary" @click="taken"/>
        <vxe-button v-if="orderStatus===0" content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="execute(0)"/>
        <vxe-button v-if="orderStatus===0" content="button.submit" icon="vxe-icon-signature" mode="text" status="success" @click="execute(1)"/>
        <vxe-button v-if="orderStatus===1" content="button.approve" icon="vxe-icon-check" mode="text" status="success" @click="execute(3)"/>
        <vxe-button v-if="orderStatus===1" content="button.reject" icon="vxe-icon-undo" mode="text" status="error" @click="execute(2)"/>
        <vxe-button v-if="orderStatus===3" content="button.submit" icon="vxe-icon-signature" mode="text" status="success" @click="execute(43)"/>
        <vxe-button v-if="orderStatus===43" content="button.approve" icon="vxe-icon-check" mode="text" status="success" @click="execute(99)"/>
      </template>
      <vxe-form ref="form" :data="order" :rules="rules" border span="8" title-align="center" title-background>
        <vxe-form-item field="no" title="business.label.orderNo"/>
        <vxe-form-item field="invoiceTime" title="business.label.invoiceTime"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:owners,props:{readonly:orderStatus>0},events:{change:()=>onOwnerChange()}}" field="owner.id" title="business.label.owner"/>
        <vxe-form-item :field="[fields[orderStatus]].operator" :title="$t('business.label.'+[fields[orderStatus]]+'Operator')">
          <template #default>
            <vxe-input v-model="order[fields[orderStatus]].operator" :editable="false" style="width: 100%" @clear="onOperatorChange([{}])" @click="onOperatorSelect"/>
            <UserModal ref="userModal" @change="onOperatorChange"/>
          </template>
        </vxe-form-item>
        <vxe-form-item :field="[fields[orderStatus]].content" :title="$t('business.label.'+[fields[orderStatus]]+'Content')" span="16">
          <template #default>
            <vxe-input v-model="order[fields[orderStatus]].content" style="width: 100%" @input="({value})=>onAdviceInput(value)"/>
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-card>
    <vxe-table ref="table" :data="details" :edit-config="{}" :edit-rules="editRules" :loading="loading" keep-source>
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="150"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="120"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="location.no" title="business.label.locationNo" width="120"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="detail.inventoryState" title="business.label.inventoryState" width="70"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',enabled:orderStatus===0}" field="detail.quantity" title="title.unqualifiedQuantity" width="120"/>
      <vxe-column v-if="orderStatus===1" :edit-render="{name:'VxeInput'}" field="detail.reasons" title="business.label.reason"/>
      <vxe-column v-if="orderStatus===1" :edit-render="{name:'VxeInput'}" field="detail.approvalAdvice" title="business.label.approvalAdviceContent"/>
      <vxe-column v-if="orderStatus===0" fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button :disabled="order.orderStatus>0" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <InventoryModal ref="inventoryModal" selectType="checkbox" @change="onInventoryChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { deleteOne, findAll, findOne, post } from '@/api/Api'
import { DisqualificationOrder } from '@/api/dto/order/DisqualificationOrder'
import UserModal from '@/views/modal/UserModal.vue'
import api from '@/api'
import { getEnums } from '@/utils/util'
import { OrderType } from '@/api/dto/common/OrderType'
import InventoryModal from '@/views/modal/InventoryModal.vue'

export default {
  components: { InventoryModal, UserModal },
  props: {
    orderType: {
      type: Object
    },
    orderStatus: { type: Number, default: null },
    owners: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new DisqualificationOrder(),
      details: [],
      inventoryStates: [],
      rules: {
        approver: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        applier: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        confirmer: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      },
      editRules: {
        'detail.quantity': [{ required: true, min: 1, type: 'number', message: '数量需大于0' }]
      },
      urls: {
        0: api.conversionQualifierSave,
        1: api.conversionQualifierSubmit,
        3: api.conversionQualifierApprove,
        2: api.conversionQualifierReject,
        43: api.conversionQualifierReport,
        99: api.conversionQualifierDestroy
      },
      fields: {
        0: 'submissionAdvice',
        1: 'approvalAdvice',
        3: 'reportAdvice',
        43: 'destructionAdvice'
      }
    }
  },
  created() {
    getEnums('InventoryState').then(result => {
      this.inventoryStates = result
    })
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onOwnerChange() {
      this.$refs.table.remove()
    },
    onOperatorSelect() {
      this.$refs.userModal.open({ available: true })
    },
    onOperatorChange(values) {
      this.order[this.fields[this.orderStatus]].operator = values[0].name
    },
    onInventoryChange(values) {
      this.loading = true
      values.forEach(item => {
        const view = {
          detail: {
            id: undefined,
            inventoryState: item.inventory.inventoryState,
            quantity: 0
          },
          sku: item.sku,
          serialNumber: item.serialNumber,
          item: item.item,
          pack: item.pack,
          lot: item.lot,
          logicalStore: item.logicalStore,
          location: item.location,
          container: item.container
        }
        this.$refs.table.insertAt(view, -1)
      })
      this.loading = false
    },
    onAdviceInput(value) {
      if (this.orderStatus === 1) {
        const fullData = this.$refs.table.getFullData()
        fullData.forEach(row => {
          row.detail.approvalAdvice = value
        })
      }
    },
    add() {
      this.order = new DisqualificationOrder()
      this.order.orderType = new OrderType(this.orderType)
      this.details = []
    },
    edit(row) {
      this.loading = true
      findOne('disqualificationOrderFactory', { id: row.order.id }).then(res => {
        if (res.success) {
          this.order = new DisqualificationOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('disqualificationDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    },
    taken() {
      if (this.order.owner.isNew()) {
        return this.$message.warning(this.$t('business.label.owner') + this.$t('message.cannotBeEmpty'))
      }
      this.$refs.inventoryModal.open({ 'owner.id': this.order.owner.id, available: true, physical: true })
    },
    async execute(orderStatus) {
      let errors = await this.$refs.form.validate()
      if (!errors) {
        if (this.$refs.table.getFullData().length === 0) {
          return this.$message.warning(this.$t('tab.orderDetail') + this.$t('message.cannotBeEmpty'))
        }
        errors = await this.$refs.table.validate(true)
        if (!errors) {
          this.loading = true
          if (!this.order[this.fields[this.orderStatus]].operator) this.order[this.fields[this.orderStatus]].operator = this.operator.name
          const order = this.order.toJSONObject()
          order.warehouse = this.warehouse
          if (orderStatus === 0 || orderStatus === 2 || orderStatus === 3) {
            order.details = (orderStatus === 0 ? this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords()) : this.$refs.table.getFullData()).map(item => {
              return {
                ...item.detail,
                sku: item.sku,
                serialNumber: item.serialNumber,
                location: item.location,
                container: item.container
              }
            })
          }
          post(this.urls[orderStatus], {}, order).then(res => {
            if (res.success) {
              this.$message.success(this.$t('message.operationSuccess'))
              if (orderStatus === 0) {
                this.order = new DisqualificationOrder(res.result)
                this.getDetails()
              } else {
                this.back()
              }
            }
          }).finally(() => this.loading = false)
        }
      }
    },
    remove(row) {
      if (row.detail.id) {
        this.loading = true
        deleteOne('disqualificationDetailDeleter', { id: row.detail.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.getDetails()
          }
        }).finally(() => this.loading = false)
      } else {
        this.$refs.table.remove(row)
      }
    }
  }
}
</script>